import React, {Component} from 'react';
import {withStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/es/Typography/Typography";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";

const styles = theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(900 + theme.spacing.unit * 3 * 2)]: {
      width: 900,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  cardHeader: {
    backgroundColor: theme.palette.grey[200],
  },
  cardActions: {
    [theme.breakpoints.up('sm')]: {
      paddingBottom: theme.spacing.unit * 2,
    },
  },
  card: {
    display: 'flex'
  },
  media: {
    width: 160,
    height: 120,
  },
});


class Home extends Component {

  constructor(props) {
    super(props);
    this.state = {showLoading: true, meets: []};
  }

  componentDidMount() {
    //firebase.firestore().collection('/meets').onSnapshot((snapshot => {}));
  }


  render() {
    const {classes} = this.props;
    return (
      <div className='home'>
        <div className={classes.layout}>
          <Typography variant="h6">3D printing</Typography>
          <br/>
          <Button variant="contained" href="https://www.etsy.com/shop/FrankkieNL/">
            Go to Esty shop
          </Button>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Home);
